import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";

import { buildConsolidatedIssueLabels } from "./wasteStreamDiscrepancyIndicator";

/**
 * Cell for the staff-only consolidated "Issues" column shared by the tenant
 * (`TenantWasteStreams`) and facility (`WasteStreamsDataGrid`) waste-stream
 * grids. Aggregates every field discrepancy + field issue on the row into one
 * semicolon-joined, ellipsized line with the full list in a tooltip. The
 * per-cell warning indicators stay; this is the consolidated, sortable view.
 * Renders nothing when the row has no surfaceable issues.
 */
export function WasteStreamIssuesCell({
  discrepancies,
}: {
  discrepancies: ReadonlyArray<{ field: string; kind?: string | null; ruleKey?: string | null }>;
}) {
  const labels = buildConsolidatedIssueLabels(discrepancies);
  if (labels.length === 0) return null;
  const text = labels.join("; ");
  return (
    <Tooltip title={text}>
      <Typography
        variant="body2"
        sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", minWidth: 0 }}
      >
        {text}
      </Typography>
    </Tooltip>
  );
}
